import store from '@/store';

class Logger {
  constructor() {
    // Lade Einstellung aus localStorage oder nutze Default
    const stored = localStorage.getItem('app_logger_enabled');
    this.enabled = stored !== null
      ? stored === 'true'
      : process.env.NODE_ENV === 'development';
  }

  enable() {
    this.enabled = true;
    localStorage.setItem('app_logger_enabled', 'true');
  }

  disable() {
    this.enabled = false;
    localStorage.setItem('app_logger_enabled', 'false');
  }

  toggle() {
    this.enabled = !this.enabled;
    localStorage.setItem('app_logger_enabled', String(this.enabled));
  }

  info(...args) {
    if (store.getters['app/debugMode']) {
      console.info('[APP]', ...args);
    }
  }

  log(...args) {
    if (store.getters['app/debugMode']) {
      console.log('[APP]', ...args);
    }
  }

  error(...args) {
    console.error('[APP]', ...args);
  }

  warn(...args) {
    if (store.getters['app/debugMode']) {
      console.warn('[APP]', ...args);
    }
  }

  // ... rest bleibt gleich
}

export default new Logger();
